import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-ienupar',
  templateUrl: './ienupar.component.html',
  styleUrls: ['./ienupar.component.scss']
})
export class IenuparComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
